import { ScrollTrigger } from '../gsap/setup';

const TABLET_MQ = '(min-width: 768px)';

let instances = [];

class ServicesNav {
  constructor(nav) {
    this.nav = nav;
    this.mq = window.matchMedia(TABLET_MQ);
    this.links = Array.from(nav.querySelectorAll('[data-services-nav]'));
    this.sections = this.links
      .map((link) => {
        const id = link.getAttribute('href')?.slice(1);

        return id ? document.getElementById(id) : null;
      })
      .filter(Boolean);
    this.triggers = [];
    this.resizeTimer = null;
    this.onMediaChange = this.setup.bind(this);
    this.onResize = this.handleResize.bind(this);

    this.mq.addEventListener('change', this.onMediaChange);
    window.addEventListener('resize', this.onResize);
    this.setup();
  }

  handleResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => this.updateSticky(), 200);
  }

  updateSticky() {
    this.nav.classList.remove('is-sticky');
    this.nav.style.removeProperty('--services-nav-height');
    this.nav.style.removeProperty('--services-nav-sticky-top');

    if (!this.mq.matches) {
      return;
    }

    const height = this.nav.offsetHeight;
    const viewportHeight = window.innerHeight;

    this.nav.style.setProperty('--services-nav-height', `${height}px`);

    if (height >= viewportHeight) {
      return;
    }

    const stickyTop = (viewportHeight - height) / 2;

    this.nav.classList.add('is-sticky');
    this.nav.style.setProperty('--services-nav-sticky-top', `${stickyTop}px`);
  }

  setActive(index) {
    this.links.forEach((link, i) => {
      const isActive = i === index;

      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  setup() {
    this.triggers.forEach((trigger) => trigger.kill());
    this.triggers = [];

    if (!this.mq.matches || !this.sections.length) {
      this.setActive(0);
      this.updateSticky();
      return;
    }

    this.setActive(0);

    this.sections.forEach((section, index) => {
      this.triggers.push(
        ScrollTrigger.create({
          trigger: section,
          start: 'top 70%',
            end: 'bottom 30%',
          onToggle: ({isActive}) => {
            if(isActive) {
              this.setActive(index);
            }
          }
        }),
      );
    });

    requestAnimationFrame(() => {
      this.updateSticky();
    });
  }

  destroy() {
    clearTimeout(this.resizeTimer);
    this.mq.removeEventListener('change', this.onMediaChange);
    window.removeEventListener('resize', this.onResize);
    this.triggers.forEach((trigger) => trigger.kill());
    this.triggers = [];
    this.nav.classList.remove('is-sticky');
    this.nav.style.removeProperty('--services-nav-height');
    this.nav.style.removeProperty('--services-nav-sticky-top');
  }
}

export function initServicesNav() {
  destroyServicesNav();

  document.querySelectorAll('.js-services-nav').forEach((nav) => {
    instances.push(new ServicesNav(nav));
  });
}

export function destroyServicesNav() {
  instances.forEach((instance) => instance.destroy());
  instances = [];
}
